if (typeof wp.data != 'undefined' && typeof wp.blocks != 'undefined') {

// Custom group control - margin / padding
(function (wp) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;
  var ToggleGroupControl = wp.components.__experimentalToggleGroupControl;
  var ToggleGroupControlOption = wp.components.__experimentalToggleGroupControlOption;

  var allowedBlocks = [
    'core/columns',
    'core/group',
    // 'acf/block-media-group',
  ];

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        themeMargin: {
          type: 'string',
          default: 'none'
        },
        themePadding: {
          type: 'string',
          default: 'small'
        },
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      controls = el(InspectorControls, {},
        el(PanelBody, {
          title: 'Options',
          initialOpen: true
        },
          el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Margin',
              className: 'toggle_group',
              value: props.attributes.themeMargin,
              onChange: (val) => props.setAttributes({ themeMargin: val }),
            },
              el(ToggleGroupControlOption, {
                label: 'None',
                value: 'none',
              }),
              el(ToggleGroupControlOption, {
                label: 'Small',
                value: 'small',
              }),
              el(ToggleGroupControlOption, {
                label: 'Large',
                value: 'large',
              }),
            ), // toggle group
          ),
          el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Padding',
              className: 'toggle_group',
              value: props.attributes.themePadding,
              onChange: (val) => props.setAttributes({ themePadding: val }),
            },
              el(ToggleGroupControlOption, {
                label: 'None',
                value: 'none',
              }),
              el(ToggleGroupControlOption, {
                label: 'Small',
                value: 'small',
              }),
              el(ToggleGroupControlOption, {
                label: 'Large',
                value: 'large',
              }),
            ), // toggle group
          ),
        )
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (!allowedBlocks.includes(props.name)) {
        return el(BlockListBlock, props);
      }

      if (typeof props.className === 'undefined') {
        props.className = '';
      }

      props.className = props.className.trim().replace(/\s+/g, ' ');

      props.className = props.className.replace(/margin_none/g, '');
      props.className = props.className.replace(/margin_small/g, '');
      props.className = props.className.replace(/margin_large/g, '');

      if (typeof props.attributes.themeMargin !== 'undefined') {
        let className = 'margin_' + props.attributes.themeMargin;
        props.className += ' ' + className;
      }

      props.className = props.className.replace(/padding_none/g, '');
      props.className = props.className.replace(/padding_small/g, '');
      props.className = props.className.replace(/padding_large/g, '');

      if (typeof props.attributes.themePadding !== 'undefined') {
        let className = 'padding_' + props.attributes.themePadding;
        props.className += ' ' + className;
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (allowedBlocks.includes(blockType.name)) {
      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      extraProps.className = extraProps.className.trim().replace(/\s+/g, ' ');

      extraProps.className = extraProps.className.replace(/margin_none/g, '');
      extraProps.className = extraProps.className.replace(/margin_small/g, '');
      extraProps.className = extraProps.className.replace(/margin_large/g, '');

      if (typeof attributes.themeMargin !== 'undefined') {
        let className = 'margin_' + attributes.themeMargin;
        extraProps.className += ' ' + className;
      }

      extraProps.className = extraProps.className.replace(/padding_none/g, '');
      extraProps.className = extraProps.className.replace(/padding_small/g, '');
      extraProps.className = extraProps.className.replace(/padding_large/g, '');

      if (typeof attributes.themePadding !== 'undefined') {
        let className = 'padding_' + attributes.themePadding;
        extraProps.className += ' ' + className;
      }
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/group-theme-custom-attributes',
    addAttributes
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/group-theme-custom-controls',
    withInspectorControls
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/group-theme-custom-class-admin',
    withCustomClassName
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/group-theme-custom-class',
    applyExtraClass
  );
})(window.wp);



// Custom Group Image
(function (wp) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;
  var Button = wp.components.Button;
  var ToggleGroupControl = wp.components.__experimentalToggleGroupControl;
  var ToggleGroupControlOption = wp.components.__experimentalToggleGroupControlOption;
  var TextControl = wp.components.TextControl;
  var MediaUpload = wp.blockEditor.MediaUpload;
  var select = wp.data.select;
  var useSelect = wp.data.useSelect;

  var allowedBlocks = [
    'core/group',
  ];

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        image: {
          type: 'int',
          default: 0
        },
        imageStyle: {
          type: 'string',
          default: 'background'
        },
        video: {
          type: 'string',
          default: null
        },
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {

    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      function selectImage(value) {
        props.setAttributes({
          image: value.id,
        });
      }

      function clearImage() {
        props.setAttributes({
          image: 0,
        });
      }

      var image = null;

      if (props.attributes.image) {
        image = useSelect(function(select) {
          return select('core').getMedia( props.attributes.image );
        }, [ props.attributes.image ]);
      }

      let controls = el(InspectorControls, {},
        el(PanelBody, {
          title: 'Media',
          initialOpen: true
        },
          el(PanelRow, {},
            el(MediaUpload, {
              onSelect: selectImage,
              allowedTypes: [ 'image' ],
              // dimensions: {
              //   minHeight: 1080,
              //   minWidth: 1600,
              // },
              render: function(renderProps) {
                //
                if (image) {
                  return el('div', {
                    class: 'group_image_preview'
                  },
                    el('img', {
                      src: image.media_details.sizes.thumbnail.source_url,
                      height: 100,
                      width: 100,
                    }),
                    el(Button, {
                        onClick: clearImage,
                        isLink: true,
                      },
                      'Remove Image'
                    ),
                  );
                } else {
                  return el(Button, {
                    onClick: renderProps.open,
                    isPrimary: true,
                  },
                    'Select Image'
                  );
                }
                //
              }
            },
            )
          ),
          el(PanelRow, {},
            el(TextControl, {
              label: 'YouTube URL',
              value: props.attributes.video,
              onChange: (val) => props.setAttributes({ video: val }),
            }),
          ),
          (image || props.attributes.video) ? el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Type',
              className: 'toggle_group',
              value: props.attributes.imageStyle,
              onChange: (val) => props.setAttributes({ imageStyle: val }),
            },
              el(ToggleGroupControlOption, {
                label: 'Background',
                value: 'background',
              }),
              el(ToggleGroupControlOption, {
                label: 'Left',
                value: 'left',
              }),
              el(ToggleGroupControlOption, {
                label: 'Right',
                value: 'right',
              }),
            ), // toggle group
          ) : null,
        )
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (!allowedBlocks.includes(props.name)) {
        return el(BlockListBlock, props);
      }

      if (typeof props.wrapperProps === 'undefined') {
        props.wrapperProps = {};
      }

      if (typeof props.className === 'undefined') {
        props.className = '';
      }

      if (typeof props.style === 'undefined') {
        props.style = '';
      }

      props.className = props.className.trim().replace(/\s+/g, ' ');

      props.className = props.className.replace(`/image-style-background/g`, '').replace(`/image-style-left/g`, '').replace(`/image-style-right/g`, '');
      props.wrapperProps.style = { '--bg_image': '' };

      if (props.attributes.image && props.attributes.imageStyle) {
        let className = 'image-style-' + props.attributes.imageStyle;
        props.className += ' ' + className;

        let image = useSelect(function(select) {
          return select('core').getMedia( props.attributes.image );
        }, [ props.attributes.image ]);

        if (image) {
          if (typeof image.media_details.sizes.full !== 'undefined') {
            props.wrapperProps.style = { '--bg_image': 'url(' + image.media_details.sizes.full.source_url + ')' };
          }
        }
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (allowedBlocks.includes(blockType.name)) {

      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      extraProps.className = extraProps.className.trim().replace(/\s+/g, ' ');

      extraProps.className = extraProps.className.replace(`/image-style-background/g`, '').replace(`/image-style-left/g`, '').replace(`/image-style-right/g`, '');

      if (attributes.image && attributes.imageStyle) {
        let className = 'image-style-' + attributes.imageStyle;
        extraProps.className += ' ' + className;
      }
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/theme-pattern-attributes',
    addAttributes
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/theme-pattern-controls',
    withInspectorControls
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/group-image-custom-class-admin',
    withCustomClassName
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/group-image-custom-class',
    applyExtraClass
  );

})(window.wp);



// Custom columns control - gap
(function (wp) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;
  var ToggleControl = wp.components.ToggleControl;

  var allowedBlocks = [
    'core/columns',
  ];

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        columnGap: {
          type: 'boolean',
          default: true
        },
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      controls = el(InspectorControls, {},
        el(PanelBody, {
          title: 'Options',
          initialOpen: true
        },
          el(PanelRow, {},
            el(ToggleControl, {
              label: 'Column Gap',
              checked: !!props.attributes.columnGap,
              onChange: () => props.setAttributes({ columnGap: !props.attributes.columnGap }),
            })
          ),
        )
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (!allowedBlocks.includes(props.name)) {
        return el(BlockListBlock, props);
      }

      if (typeof props.className === 'undefined') {
        props.className = '';
      }

      props.className = props.className.trim().replace(/\s+/g, ' ');

      props.className = props.className.replace(/no_gap/g, '');

      if (typeof props.attributes.columnGap !== 'undefined') {
        props.className += props.attributes.columnGap ? ' has_gap' : ' no_gap';
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (allowedBlocks.includes(blockType.name)) {
      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      extraProps.className = extraProps.className.trim().replace(/\s+/g, ' ');

      extraProps.className = extraProps.className.replace(/no_gap/g, '');

      if (typeof attributes.columnGap !== 'undefined') {
        extraProps.className += attributes.columnGap ? ' has_gap' : ' no_gap';
      }
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/columns-theme-custom-attributes',
    addAttributes
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/columns-theme-custom-controls',
    withInspectorControls
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/columns-theme-custom-class-admin',
    withCustomClassName
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/columns-theme-custom-class',
    applyExtraClass
  );
})(window.wp);


// Custom column control - border
(function (wp) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;
  var ToggleControl = wp.components.ToggleControl;

  var allowedBlocks = [
    'core/column',
  ];

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        hasBorder: {
          type: 'boolean',
          default: false
        },
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      controls = el(InspectorControls, {},
        el(PanelBody, {
          title: 'Options',
          initialOpen: true
        },
          el(PanelRow, {},
            el(ToggleControl, {
              label: 'Bordered',
              checked: !!props.attributes.hasBorder,
              onChange: () => props.setAttributes({ hasBorder: !props.attributes.hasBorder }),
            })
          ),
        )
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (!allowedBlocks.includes(props.name)) {
        return el(BlockListBlock, props);
      }

      if (typeof props.className === 'undefined') {
        props.className = '';
      }

      props.className = props.className.trim().replace(/\s+/g, ' ');

      props.className = props.className.replace(/has_border/g, '');

      if (props.attributes.hasBorder) {
        props.className += ' has_border';
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (allowedBlocks.includes(blockType.name)) {
      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      extraProps.className = extraProps.className.trim().replace(/\s+/g, ' ');

      extraProps.className = extraProps.className.replace(/has_border/g, '');

      if (attributes.hasBorder) {
        extraProps.className += ' has_border';
      }
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/column-theme-custom-attributes',
    addAttributes
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/column-theme-custom-controls',
    withInspectorControls
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/column-theme-custom-class-admin',
    withCustomClassName
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/column-theme-custom-class',
    applyExtraClass
  );
})(window.wp);



// Custom list control - icons
(function (wp) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;
  var ToggleControl = wp.components.ToggleControl;

  var allowedBlocks = [
    'core/list',
  ];

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        iconMarker: {
          type: 'boolean',
          default: false
        },
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      controls = el(InspectorControls, {},
        el(PanelBody, {
          title: 'Options',
          initialOpen: true
        },
          el(PanelRow, {},
            el(ToggleControl, {
              label: 'Icon Marker',
              checked: !!props.attributes.iconMarker,
              onChange: () => props.setAttributes({ iconMarker: !props.attributes.iconMarker }),
            })
          ),
        )
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (!allowedBlocks.includes(props.name)) {
        return el(BlockListBlock, props);
      }

      if (typeof props.className === 'undefined') {
        props.className = '';
      }

      props.className = props.className.trim().replace(/\s+/g, ' ');

      props.className = props.className.replace(/icon_marker/g, '');

      if (props.attributes.iconMarker) {
        props.className += ' icon_marker';
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (allowedBlocks.includes(blockType.name)) {
      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      extraProps.className = extraProps.className.trim().replace(/\s+/g, ' ');

      extraProps.className = extraProps.className.replace(/icon_marker/g, '');

      if (attributes.iconMarker) {
        extraProps.className += ' icon_marker';
      }
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/list-theme-custom-attributes',
    addAttributes
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/list-theme-custom-controls',
    withInspectorControls
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/list-theme-custom-class-admin',
    withCustomClassName
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/list-theme-custom-class',
    applyExtraClass
  );
})(window.wp);




// Custom Pattern Styles
(function (wp) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;
  var Button = wp.components.Button;
  var ButtonGroup = wp.components.ButtonGroup;
  // var Icon = wp.components.Icon;
  var ToggleGroupControl = wp.components.__experimentalToggleGroupControl;
  var ToggleGroupControlOption = wp.components.__experimentalToggleGroupControlOption;
  // var TextControl = wp.components.TextControl;
  var MediaUpload = wp.blockEditor.MediaUpload;
  var select = wp.data.select;
  var useSelect = wp.data.useSelect;

  var allPatterns = {
    'green': 'public/images/pattern-green.jpg',
    'red': 'public/images/pattern-red.jpg',
    'blue': 'public/images/pattern-blue.jpg',
    'yellow': 'public/images/pattern-yellow.jpg'
  };

  var allowedBlocks = [
    'core/group',
    //
    'acf/block-poster',
    'acf/block-vignette',
    //
    'acf/block-billboard',
    'acf/block-promo',
    'acf/block-stats',
    'acf/block-timeline',
  ];

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        patternType: {
          type: 'string',
          default: 'theme'
        },
        patternStyle: {
          type: 'string',
          default: (settings.name == 'core/group') ? '' : 'green',
        },
        patternImage: {
          type: 'int',
          default: 0
        },
        patternImageStyle: {
          type: 'string',
          default: 'dark'
        },
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {

    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      //

      let patternControls = [];

      for (let pattern in allPatterns) {
        let src = allPatterns[ pattern ];
        let isSVG = (src.indexOf('<svg') > -1);

        patternControls.push(
          el(Button, {
              text: pattern,
              isPressed: (props.attributes.patternStyle == pattern),
              className: 'value-' + pattern,
              onClick: () => props.setAttributes({ patternStyle: pattern }),
            },
            isSVG ?
              wp.element.RawHTML( { children: src } ) :
              el('img', {
                src: THEME_URI + '/' + src,
                height: 100,
                width: 100,
              }),
          )
        );
      }

      //

      function selectImage(value) {
        props.setAttributes({
          patternImage: value.id,
        });
      }

      function clearImage() {
        props.setAttributes({
          patternImage: 0,
        });
      }

      function clearPattern() {
        props.setAttributes({
          patternStyle: 0,
        });
      }

      var image = null;

      if (props.attributes.patternImage) {
        image = useSelect(function(select) {
          return select('core').getMedia( props.attributes.patternImage );
        }, [ props.attributes.patternImage ]);
      }

      let controls = el(InspectorControls, {},
        el(PanelBody, {
          title: 'Pattern',
          initialOpen: true
        },
          //
          (props.name !== 'core/group') ? el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Type',
              className: 'toggle_group',
              value: props.attributes.patternType,
              onChange: (val) => props.setAttributes({ patternType: val }),
            },
              el(ToggleGroupControlOption, {
                label: 'Theme',
                value: 'theme',
              }),
              el(ToggleGroupControlOption, {
                label: 'Custom',
                value: 'custom',
              }),
            ), // toggle group
          ) : null,
          //
          (props.attributes.patternType == 'theme') ? el(PanelRow, {},
            el(
              ...[ButtonGroup, {
                className: 'visual_options visual_options-pattern_style'
              }].concat(patternControls)
            ), // button group
          ) : null,

          (props.name == 'core/group') ? el(PanelRow, {},
            el(Button, {
                onClick: clearPattern,
                isLink: true,
              },
              'Clear'
            ),
          ) : null,
          //
          (props.attributes.patternType == 'custom') ? el(PanelRow, {},
            el(MediaUpload, {
              onSelect: selectImage,
              allowedTypes: [ 'image' ],
              // dimensions: {
              //   minHeight: 1080,
              //   minWidth: 1600,
              // },
              render: function(renderProps) {
                //
                if (image) {
                  return el('div', {
                    class: 'group_image_preview'
                  },
                    el('img', {
                      src: image.media_details.sizes.thumbnail.source_url,
                      height: 100,
                      width: 100,
                    }),
                    el(Button, {
                        onClick: clearImage,
                        isLink: true,
                      },
                      'Remove Image'
                    ),
                  );
                } else {
                  return el(Button, {
                    onClick: renderProps.open,
                    isPrimary: true,
                  },
                    'Select Image'
                  );
                }
                //
              }
            },
            ),
          ) : null,
          (props.attributes.patternType == 'custom') ? el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Style',
              className: 'toggle_group',
              value: props.attributes.patternImageStyle,
              onChange: (val) => props.setAttributes({ patternImageStyle: val }),
            },
              el(ToggleGroupControlOption, {
                label: 'Dark Image',
                value: 'dark',
              }),
              el(ToggleGroupControlOption, {
                label: 'Light Image',
                value: 'light',
              }),
            ), // toggle group
          ) : null,
          //
          // el(PanelRow, {},
          //   el(TextControl, {
          //     label: 'YouTube URL',
          //     value: props.attributes.video,
          //     onChange: (val) => props.setAttributes({ video: val }),
          //   }),
          // ),

        )
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (!allowedBlocks.includes(props.name)) {
        return el(BlockListBlock, props);
      }

      if (typeof props.wrapperProps === 'undefined') {
        props.wrapperProps = {};
      }

      if (typeof props.className === 'undefined') {
        props.className = '';
      }

      if (typeof props.style === 'undefined') {
        props.style = '';
      }

      props.className = props.className.trim().replace(/\s+/g, ' ');

      props.className = props.className.replace(`/theme-pattern/g`, '')
        .replace(`/theme-text-pattern/g`, '')
        .replace(`/theme-pattern-green/g`, '')
        .replace(`/theme-pattern-red/g`, '')
        .replace(`/theme-pattern-blue/g`, '')
        .replace(`/theme-pattern-yellow/g`, '');

      // props.wrapperProps.style = { '--bg_image': '' };

      if (props.attributes.patternStyle) {
        let className = 'theme-pattern theme-text-pattern theme-pattern-' + props.attributes.patternStyle;
        props.className += ' ' + className;

        // let image = useSelect(function(select) {
        //   return select('core').getMedia( props.attributes.image );
        // }, [ props.attributes.image ]);

        // if (image) {
        //   if (typeof image.media_details.sizes.full !== 'undefined') {
        //     props.wrapperProps.style = { '--bg_image': 'url(' + image.media_details.sizes.full.source_url + ')' };
        //   }
        // }
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (allowedBlocks.includes(blockType.name)) {

      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      extraProps.className = extraProps.className.trim().replace(/\s+/g, ' ');

      extraProps.className = extraProps.className.replace(`/theme-pattern/g`, '')
        .replace(`/theme-text-pattern/g`, '')
        .replace(`/theme-pattern-green/g`, '')
        .replace(`/theme-pattern-red/g`, '')
        .replace(`/theme-pattern-blue/g`, '')
        .replace(`/theme-pattern-yellow/g`, '');

      if (attributes.patternStyle) {
        let className = 'theme-pattern theme-text-pattern theme-pattern-' + attributes.patternStyle;
        extraProps.className += ' ' + className;
      }
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/theme-pattern-attributes',
    addAttributes,
    999
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/theme-pattern-controls',
    withInspectorControls,
    999
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/theme-pattern-custom-class-admin',
    withCustomClassName,
    999
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/theme-pattern-custom-class',
    applyExtraClass,
    999
  );

})(window.wp);



// // Custom button control - arrow icons
// (function (wp) {
//   var el = wp.element.createElement;
//   var Fragment = wp.element.Fragment;
//   var InspectorControls = wp.blockEditor.InspectorControls;
//   var PanelBody = wp.components.PanelBody;
//   var PanelRow = wp.components.PanelRow;
//   var ToggleControl = wp.components.ToggleControl;

//   var allowedBlocks = [
//     'core/button',
//   ];

//   function addAttributes(settings) {
//     if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
//       settings.attributes = Object.assign(settings.attributes, {
//         arrowIcon: {
//           type: 'boolean',
//           default: true
//         },
//       });
//     }

//     return settings;
//   }

//   var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
//     return function(props) {
//       if (!props.isSelected || !allowedBlocks.includes(props.name)) {
//         return el(Fragment, {},
//           el(BlockEdit, props)
//         );
//       }

//       controls = el(InspectorControls, {},
//         el(PanelBody, {
//           title: 'Options',
//           initialOpen: true
//         },
//           el(PanelRow, {},
//             el(ToggleControl, {
//               label: 'Include Icon',
//               checked: !!props.attributes.arrowIcon,
//               onChange: () => props.setAttributes({ arrowIcon: !props.attributes.arrowIcon }),
//             })
//           ),
//         )
//       );

//       return el(Fragment, {},
//         el(BlockEdit, props),
//         controls,
//       );
//     };
//   }, 'withInspectorControls');

//   // var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
//   //   return function(props) {
//   //     if (!allowedBlocks.includes(props.name)) {
//   //       return el(BlockListBlock, props);
//   //     }

//   //     if (typeof props.className === 'undefined') {
//   //       props.className = '';
//   //     }

//   //     props.className = props.className.replace(/has_icon/g, '');

//   //     if (typeof props.attributes.arrowIcon !== 'undefined' && props.attributes.arrowIcon == true) {
//   //       props.className += ' has_icon';
//   //     }

//   //     return el(BlockListBlock, props);
//   //   };
//   // }, 'withInspectorControls');

//   // function applyExtraClass(extraProps, blockType, attributes) {
//   //   if (allowedBlocks.includes(blockType.name)) {
//   //     if (typeof extraProps.className === 'undefined') {
//   //       extraProps.className = '';
//   //     }

//   //     extraProps.className = extraProps.className.replace(/has_icon/g, '');

//   //     if (typeof attributes.arrowIcon !== 'undefined' && attributes.arrowIcon == true) {
//   //       extraProps.className += ' has_icon';
//   //     }

//   //     console.log(attributes.arrowIcon, extraProps.className);
//   //   }

//   //   return extraProps;
//   // }

//   wp.hooks.addFilter(
//     'blocks.registerBlockType',
//     'theme/button-theme-custom-attributes',
//     addAttributes
//   );

//   wp.hooks.addFilter(
//     'editor.BlockEdit',
//     'theme/button-theme-custom-controls',
//     withInspectorControls
//   );

//   // wp.hooks.addFilter(
//   //   'editor.BlockListBlock',
//   //   'theme/button-theme-custom-class-admin',
//   //   withCustomClassName
//   // );

//   // wp.hooks.addFilter(
//   //   'blocks.getSaveContent.extraProps',
//   //   'theme/button-theme-custom-class',
//   //   applyExtraClass
//   // );
// })(window.wp);



// // Heading controls
// (function (wp) {
//   var el = wp.element.createElement;
//   var Fragment = wp.element.Fragment;
//   var InspectorControls = wp.blockEditor.InspectorControls;
//   var PanelBody = wp.components.PanelBody;
//   var PanelRow = wp.components.PanelRow;
//   var ToggleControl = wp.components.ToggleControl;

//   var allowedBlocks = [
//     'core/heading',
//   ];

//   function addAttributes(settings) {
//     if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
//       settings.attributes = Object.assign(settings.attributes, {
//         // allCaps: {
//         //   type: 'boolean',
//         //   default: true
//         // },
//         hasOrnament: {
//           type: 'boolean',
//           default: false
//         },
//       });
//     }

//     return settings;
//   }

//   var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
//     return function(props) {
//       if (!props.isSelected || !allowedBlocks.includes(props.name)) {
//         return el(Fragment, {},
//           el(BlockEdit, props)
//         );
//       }

//       controls = el(InspectorControls, {},
//         el(PanelBody, {
//           title: 'Options',
//           initialOpen: true
//         },
//           // el(PanelRow, {},
//           //   el(ToggleControl, {
//           //     label: 'All Caps',
//           //     checked: !!props.attributes.allCaps,
//           //     onChange: () => props.setAttributes({ allCaps: !props.attributes.allCaps }),
//           //   })
//           // ),
//           el(PanelRow, {},
//             el(ToggleControl, {
//               label: 'Display Ornament',
//               checked: !!props.attributes.hasOrnament,
//               onChange: () => props.setAttributes({ hasOrnament: !props.attributes.hasOrnament }),
//             })
//           ),
//         ),
//       );

//       return el(Fragment, {},
//         el(BlockEdit, props),
//         controls,
//       );
//     };
//   }, 'withInspectorControls');

//   var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
//     return function(props) {
//       if (allowedBlocks.includes(props.name)) {
//         if (typeof props.className === 'undefined') {
//           props.className = '';
//         }

//         props.className = props.className.replace(/has_ornament/g, '');

//         if (props.attributes.hasOrnament) {
//           props.className += ' has_ornament';
//         }
//       }

//       return el(BlockListBlock, props);
//     };
//   }, 'withInspectorControls');

//   function applyExtraClass(extraProps, blockType, attributes) {
//     if (allowedBlocks.includes(blockType.name)) {
//       if (typeof extraProps.className === 'undefined') {
//         extraProps.className = '';
//       }

//       extraProps.className = extraProps.className.replace(/has_ornament/g, '');

//       if (attributes.hasOrnament) {
//         extraProps.className += ' has_ornament';
//       }
//     }

//     return extraProps;
//   }

//   wp.hooks.addFilter(
//     'blocks.registerBlockType',
//     'theme/heading-custom-attributes',
//     addAttributes
//   );

//   wp.hooks.addFilter(
//     'editor.BlockEdit',
//     'theme/heading-custom-controls',
//     withInspectorControls
//   );

//   wp.hooks.addFilter(
//     'editor.BlockListBlock',
//     'theme/heading-custom-class-admin',
//     withCustomClassName
//   );

//   wp.hooks.addFilter(
//     'blocks.getSaveContent.extraProps',
//     'theme/heading-custom-class',
//     applyExtraClass
//   );
// })(window.wp);



// Custom paragraph highlight

// (function(wp) {
//   var withSelect  = wp.data.withSelect;
//   var ifCondition = wp.compose.ifCondition;
//   var compose     = wp.compose.compose;

//   var HighlightParagraphButton = function(props) {
//       return wp.element.createElement(
//           wp.blockEditor.RichTextToolbarButton,
//           {
//               icon: 'admin-customizer',
//               title: '-Highlight',
//               onClick: function() {
//                   props.onChange(
//                       wp.richText.toggleFormat(props.value, {
//                           type: 'warschawski/paragraph-highlight'
//                       })
//                   );
//               }
//           }
//       );
//   }

//   var ConditionalHighlightParagraphButton = compose(
//       withSelect(function(select) {
//           return {
//               selectedBlock: select('core/block-editor').getSelectedBlock()
//           }
//       }),
//       ifCondition(function(props) {
//           return (
//               props.selectedBlock &&
//               // props.selectedBlock.name === 'core/heading'
//               props.selectedBlock.name === 'core/paragraph'
//               // (props.selectedBlock.name === 'core/heading' || props.selectedBlock.name === 'core/paragraph')
//           );
//       })
//   )(HighlightParagraphButton);

//   wp.richText.registerFormatType(
//       'warschawski/paragraph-highlight', {
//           title: '-Hightlight',
//           tagName: 'span',
//           className: 'highlight',
//           edit: ConditionalHighlightParagraphButton,
//       }
//   );
// })(window.wp);


// TODO fix button alignment
// // Custom button alignment
// (function (wp) {
//   var allowedBlocks = [
//     'core/buttons',
//   ];

//   function applyExtraClass(extraProps, blockType, attributes) {
//     // if (allowedBlocks.includes(blockType.name)) {
//     //   console.log(attributes);
//     // }
//     if (typeof attributes.align !== 'undefined' && allowedBlocks.includes(blockType.name)) {

//       if (typeof extraProps.className === 'undefined') {
//         extraProps.className = '';
//       }
//       // if (typeof attributes.className === 'undefined') {
//       //   attributes.className = '';
//       // }

//       if (attributes.align) {
//         if (extraProps.className.indexOf('align') < 0) {
//           extraProps.className += 'align' + attributes.align;
//           // attributes.className += 'align' + attributes.align;
//         }
//       } else {
//         extraProps.className = extraProps.className.replace(/align_left/g, '').replace(/align_center/g, '').replace(/align_right/g, '');
//         // attributes.className = attributes.className.replace(/align_left/g, '').replace(/align_center/g, '').replace(/align_right/g, '');
//       }

//       console.log(extraProps, attributes);
//     }

//     return extraProps;
//   }

//   wp.hooks.addFilter(
//     'blocks.getSaveContent.extraProps',
//     'theme/buttons-custom-class',
//     applyExtraClass
//   );
// })(window.wp);





}
